<template>
  <div class="tracking-page seccion-gris">
    <template v-if="list_cdp.length == 0">
      <br />
      <br />
      <h3>Usted aun no ha realizado compras o pedidos.</h3>
      <div class="error-actions">
        <router-link to="/productos">Seguir comprando</router-link>
      </div>
      <br />
      <br />
    </template>
    <template v-if="cdp_anulado == true">
      <br />
      <br />
      <h3>Su pedido ha sido anulado. Revise su email para mas información.</h3>
      <div class="error-actions">
        <router-link to="/productos">Seguir comprando</router-link>
      </div>
      <br />
      <br />
    </template>
    <template v-else>
      <section>
        <div class="container">
          <div class="bloque breadcrumbs">
            <ul style="text-align: left;">
              <li><a href="#">Mis órdenes</a></li>
              <li><a class="active">Seguimiento</a></li>
            </ul>
          </div>
          <div class="bloque">
            <div class="row resumen-orden">
              <div class="col-md-6 numero-orden">
                <div class="numero-orden-titulo">Número de pedido:</div>
                <div class="numero-orden-numero">{{ last_cdp.cod_erp }}</div>
              </div>
              <div class="col-md-6 precio-fecha">
                <div class="precio-total">Total:{{ last_cdp.total | currency }}</div>
                <div class="fecha-compra">
                  Fecha y hora de compra: {{ last_cdp.date_reg | formatDate }}
                </div>
              </div>
            </div>

            <div class="row despacho">
              <div class="col-lg-9 despacho-detalle">
                <br />

                <template v-if="last_cdp.state_tracking.id_state != 7">
                  <div class="tracking">
                    <template v-if="anulacionxmodal == true">
                      <div class="alert alert-danger" role="alert">
                        <strong
                          >Advertencia: Este pedido fue anulado a petición suya. Revise su e-mail
                          para mayor información,</strong
                        >
                      </div>
                      <br />
                    </template>

                    <h2>Tracking</h2>
                    <div class="tracking-base">
                      <ul>
                        <li class="superado">
                          <div class="tracking-estado">
                            <div class="tracking-hito">Pedido recibido</div>
                            <div class="tracking-notificacion">
                              <i class="fa fa-check" aria-hidden="true"></i>
                              <p>
                                Progreso según lo esperado para la entrega el
                                <strong>Jueves 09/07</strong>
                              </p>
                            </div>
                          </div>
                        </li>

                        <template v-if="last_cdp.state_tracking.id_state >= 2">
                          <li class="superado">
                            <div class="tracking-estado">
                              <div class="tracking-hito">Pedido confirmado</div>
                            </div>
                          </li>
                        </template>
                        <template v-else>
                          <li>
                            <div class="tracking-estado">
                              <div class="tracking-hito">Pedido confirmado</div>
                            </div>
                          </li>
                        </template>

                        <template v-if="last_cdp.state_tracking.id_state >= 3">
                          <li class="superado">
                            <div class="tracking-estado">
                              <div class="tracking-hito">Preparando tu pedido</div>
                            </div>
                          </li>
                        </template>
                        <template v-else>
                          <li>
                            <div class="tracking-estado">
                              <div class="tracking-hito">Preparando tu pedido</div>
                            </div>
                          </li>
                        </template>

                        <template v-if="last_cdp.state_tracking.id_state >= 4">
                          <li class="superado">
                            <div class="tracking-estado">
                              <div class="tracking-hito">Tu pedido está en camino</div>
                            </div>
                          </li>
                        </template>
                        <template v-else>
                          <li>
                            <div class="tracking-estado">
                              <div class="tracking-hito">Tu pedido está en camino</div>
                            </div>
                          </li>
                        </template>

                        <template v-if="last_cdp.state_tracking.id_state >= 5">
                          <li class="superado">
                            <div class="tracking-estado">
                              <div class="tracking-hito">Pedido entregado</div>
                            </div>
                          </li>
                        </template>
                        <template v-else>
                          <li>
                            <div class="tracking-estado">
                              <div class="tracking-hito">Pedido entregado</div>
                            </div>
                          </li>
                        </template>
                      </ul>
                    </div>
                  </div>
                </template>
              </div>
              <div class="col-lg-3 despacho-botones">
                <ul>
                  <template v-if="url_factura != ''">
                    <li>
                      <a
                        class="btn btn-primary btn-despacho"
                        target="_blank"
                        :href="url_factura"
                        role="button"
                        >Ver comprobante</a
                      >
                    </li>
                  </template>
                  <template
                    v-if="
                      (last_cdp.state_tracking.id_state == 1 ||
                        last_cdp.state_tracking.id_state == 2 ||
                        last_cdp.state_tracking.id_state == 3) &&
                        anulacionxmodal == false
                    "
                  >
                    <li>
                      <button
                        class="btn btn-primary btn-despacho"
                        data-toggle="modal"
                        data-target="#cancelModal"
                        role="button"
                      >
                        Anular pedido
                      </button>
                    </li>
                  </template>
                  <li>
                    <router-link
                      :to="'/guia'"
                      class="btn btn-primary btn-despacho"
                      role="button"
                      aria-disabled="true"
                      >¿Necesitas ayuda?</router-link
                    >
                  </li>
                  <template v-if="isCDPerpdata">
                    <li>
                      <button
                        class="btn btn-primary btn-despacho"
                        data-toggle="modal"
                        data-target="#detailModal"
                        role="button"
                      >
                        Ver Documentos
                      </button>
                    </li>
                  </template>
                </ul>
              </div>
              <div class="col-lg-9 despacho-detalle">
                <div class="despacho-modo" style=" text-align: left;">
                  <strong>Información del producto </strong>
                </div>

                <div
                  class="despacho-producto"
                  v-for="product in last_cdp.ventas_detalle"
                  v-bind:key="product.code_product"
                >
                  <div class="despacho-producto-foto">
                    <img
                      v-bind:src="imgPreUrl + product.photo_product + '.jpg'"
                      :alt="product.name_product_es"
                    />
                  </div>
                  <div class="despacho-producto-detalle">
                    <div class="despacho-producto-detalle-nombre">
                      <strong>{{ product.name_product_es }}</strong>
                    </div>
                    <div class="despacho-producto-detalle-precio">
                      {{ product.sale_price | currency }}
                    </div>
                    <div class="despacho-producto-detalle-nota">*Precio de referencia</div>
                    <div class="despacho-producto-detalle-cantidad">
                      {{ product.quantity }} unidad(es)
                    </div>
                    <div class="despacho-producto-detalle-precio">
                      Subtotal: {{ product.subtotal | currency }}
                    </div>
                    <div v-if="product.sale_discount != 0" class="despacho-producto-detalle-precio">
                      Descuento: {{ product.sale_discount + '%' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="separador" />

            <div class="container">
              <div class="row">
                <div class="col-sm-12">
                  <div class="container">
                    <br />
                    <br />
                    <div class="despacho-modo" style=" text-align: left;">
                      <strong>Información de Despacho</strong>
                    </div>

                    <div class="row">
                      <div class="col-sm-6" style=" text-align: left;">
                        <p><strong>Cliente</strong></p>
                      </div>
                      <div class="col-sm-6" style=" text-align: right;">
                        <p>
                          {{
                            last_cdp.nick_client.name_client +
                              ' ' +
                              last_cdp.nick_client.surname_client
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6" style=" text-align: left;">
                        <p><strong>Tipo de Despacho</strong></p>
                      </div>
                      <div class="col-sm-6" style=" text-align: right;">
                        <p>{{ delivery_detail.id_type_delivery.desc_type_delivery_es }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6" style=" text-align: left;">
                        <p><strong>Día estimado de despacho</strong></p>
                      </div>
                      <div class="col-sm-6" style=" text-align: right;">
                        <p>{{ delivery_detail_cdp.dia_entrega | esDate }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6" style=" text-align: left;">
                        <p><strong>Costo de despacho</strong></p>
                      </div>
                      <div class="col-sm-6" style=" text-align: right;">
                        <p>
                          {{
                            last_cdp.total - subtotal_real < 1
                              ? 0
                              : delivery_detail.delivery_cost | currency
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6" style=" text-align: left;">
                        <p><strong>Horario de despacho</strong></p>
                      </div>
                      <div class="col-sm-6" style=" text-align: right;">
                        <p><span v-html="delivery_detail.delivery_schedule"></span></p>
                      </div>
                    </div>

                    <template v-if="delivery_detail.id_type_delivery.id_type_delivery == 1">
                      <div class="row">
                        <div class="col-sm-6" style=" text-align: left;">
                          <p><strong>Dirección de despacho</strong></p>
                        </div>
                        <div class="col-sm-6" style=" text-align: right;">
                          <p>{{ delivery_detail_cdp.detalle_ubicacion | striphtml }}</p>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="row">
                        <div class="col-sm-6" style=" text-align: left;">
                          <p><strong>Dirección de despacho</strong></p>
                        </div>
                        <div class="col-sm-6" style=" text-align: right;">
                          <p><span v-html="delivery_detail.delivery_place"></span></p>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <hr class="separador" />
            <div class="row despacho">
              <div class="container">
                <div class="despacho-modo" style=" text-align: left;">
                  <strong>Cronología</strong>
                </div>
              </div>
              <div class="row timeline-destino">
                <div class="col-sm-12">
                  <div class="container">
                    <div class="despacho-timeline">
                      <h2>Acciones</h2>
                      <ul style="text-align: left;">
                        <li
                          v-for="(track, index) in list_track"
                          :class="index + 1 == list_track.length ? 'activo' : ''"
                          v-bind:key="track.id_tracking"
                        >
                          <div class="timeline-fecha">{{ track.fecha_reg | formatDate }}</div>
                          <div class="timeline-evento">
                            {{ track.state.desc_state + ': ' + track.commentary }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <template v-if="last_cdp.state_tracking.id_state >= 3">
                <div
                  class="modal fade"
                  id="cancelModal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Advertencia</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <template
                          v-if="
                            loading_correo_anulacion &&
                              mensaje_correo_anulacion === '' &&
                              mensaje_correo_error_anulacion === ''
                          "
                        >
                          <i class="fa fa-refresh fa-spin fa-3x fa-fw fa-mrbig"></i>
                        </template>
                        <template v-else>
                          <br />
                          Este es el primer paso para anular un pedido, para continuar el proceso un asesor se comunicará con usted
                        </template>
                        <br />
                        <div
                          :class="[
                            mensaje_correo_anulacion === '' ? 'd-none' : 'alert alert-success',
                          ]"
                          role="alert"
                        >
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            @click="ocultar_anulacion()"
                          >
                            &times;</button
                          ><strong>{{ mensaje_correo_anulacion }}</strong>
                        </div>
                        <div
                          :class="[
                            mensaje_correo_error_anulacion === '' ? 'd-none' : 'alert alert-danger',
                          ]"
                          role="alert"
                        >
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            @click="ocultar_anulacion()"
                          >
                            &times;</button
                          ><strong><span v-html="mensaje_correo_error_anulacion"></span></strong>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-primary btn-despacho"
                          @click="anular2(last_cdp.cod_cdp)"
                        >
                          Si
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary btn-despacho"
                          data-dismiss="modal"
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <!-- Modal -->
                <div
                  class="modal fade"
                  id="cancelModal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Advertencia</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <template
                          v-if="
                            loading_anulacion &&
                              mensaje_anulacion === '' &&
                              mensaje_error_anulacion === ''
                          "
                        >
                          <i class="fa fa-refresh fa-spin fa-3x fa-fw fa-mrbig"></i>
                        </template>
                        <template v-else>
                          <br />
                          ¿Está seguro de que desea anular su pedido? Recuerde que si Anula su
                          pedido la devolución del dinero puede tomar 10 días laborales.
                          <br />
                        </template>
                        <br />
                        <div
                          :class="[mensaje_anulacion === '' ? 'd-none' : 'alert alert-success']"
                          role="alert"
                        >
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            @click="ocultar_anulacion()"
                          >
                            &times;</button
                          ><strong>{{ mensaje_anulacion }}</strong>
                        </div>
                        <div
                          :class="[
                            mensaje_error_anulacion === '' ? 'd-none' : 'alert alert-danger',
                          ]"
                          role="alert"
                        >
                          <button
                            type="button"
                            class="close"
                            data-dismiss="alert"
                            @click="ocultar_anulacion()"
                          >
                            &times;</button
                          ><strong><span v-html="mensaje_error_anulacion"></span></strong>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-secondary btn-despacho"
                          data-dismiss="modal"
                        >
                          Cerrar
                        </button>
                        <button
                          type="button"
                          :class="[
                            mensaje_anulacion != '' ? 'd-none' : 'btn btn-primary btn-despacho',
                          ]"
                          @click="anular(last_cdp.cod_cdp)"
                        >
                          Confirmar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div
                class="modal fade"
                id="detailModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        <strong>Documentos</strong>
                      </h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <table class="table table-responsive">
                          <thead>
                            <tr>
                              <th scope="col">Nombre Artículo</th>
                              <th scope="col">Pedido</th>
                              <th scope="col">Fecha</th>
                              <th scope="col">N' Factura</th>
                              <th scope="col">HT</th>
                              <th scope="col">HS</th>
                              <th scope="col">COA</th>
                              <th scope="col">Factura Boleta</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template v-for="item in listaArticulos">
                              <tr v-bind:key="item.articulo">
                                <td>{{ item.descripcion }}</td>
                                <td>{{ item.pedido }}</td>
                                <td>{{ item.fecha }}</td>
                                <td>{{ item.factura }}</td>
                                <td>
                                  <a :href="item.url_Ht" target="_blank"
                                    ><i class="fa fa-save"></i
                                  ></a>
                                </td>
                                <td>
                                  <a :href="item.url_Hs" target="_blank"
                                    ><i class="fa fa-save"></i
                                  ></a>
                                </td>
                                <td>
                                  <a :href="item.url_Coa" target="_blank"
                                    ><i class="fa fa-save"></i
                                  ></a>
                                </td>
                                <td>
                                  <a :href="item.url_Factura" target="_blank"
                                    ><i class="fa fa-save"></i
                                  ></a>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary btn-despacho"
                        data-dismiss="modal"
                      >
                        Cerrar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <GoToTrackingModule />
    <GuideModule />
  </div>
</template>

<script>
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import Vue from 'vue';
import toastr from 'toastr';
import axios from 'axios';
import { successToaster, errorToaster } from '../../components/shared/service/ErrorHandler.js';
import { config_settings } from '@/config.js';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const CONFLICT = 409;
const INTERNAL_SERVER_ERROR = 500;

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.message === 'Network Error') {
      toastr.error(
        'No se puede conectar con el servidor. Verifique su conexión a internet',
        'ERROR',
        { iconClass: 'customer-danger' },
      );
    } else if (error.response.status === UNAUTHORIZED) {
      if (error.response.data.message === 'Access is denied') {
        toastr.error('Usted no tiene los provilegios para acceder a esta sección', 'ERROR', {
          iconClass: 'customer-danger',
        });
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default {
  name: 'CreateAccount',
  created() {
    this.scroll_inicio();
    this.get_cdp_data();
  },
  data() {
    return {
      crit: 5,
      pages: [],
      final_page: 1,
      current_page: 1,
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      url_image_preview: config_settings.PHOTO_SERVER_URL + '/clients/empty-img.jpg',
      image_portada: config_settings.PHOTO_SERVER_URL + '/clients/empty-img',
      mensaje: '',
      mensaje_error: '',
      list_cdp: [],
      list_track: [],
      token: localStorage.getItem('access_token'),
      refresh_token: localStorage.getItem('refresh_token'),
      last_cdp: '',
      selected_cdp: this.$route.params.id,
      cdp_anulado: false,
      delivery_detail: '',
      delivery_detail_cdp: '',
      loading_anulacion: false,
      mensaje_anulacion: '',
      mensaje_error_anulacion: '',
      anulacionxmodal: false,
      loading_correo_anulacion: false,
      mensaje_correo_anulacion: '',
      mensaje_correo_error_anulacion: '',
      subtotal_real: 0.0,
      cdp_erp_data: '',
      url_factura: '',
      isCDPerpdata: false,
      listaArticulos: [],
    };
  },
  components: { GoToTrackingModule, GuideModule },

  watch: {
    $route: function(route) {
      this.selected_cdp = route.params.id;
      this.scroll_inicio();
      this.get_cdp_data();
    },
  },
  methods: {
    anular(cod_cdp) {
      this.loading_anulacion = true;
      axios({
        method: 'put',
        url: config_settings.RESOURCE_SERVER_URL + '/PUT/cdp/' + cod_cdp + '/null_pre_track',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.mensaje_anulacion = 'Su pedido fue anulado con éxito';
          this.loading_anulacion = false;
          this.anulacionxmodal = true;
          //this.scroll_inicio();
          //this.get_cdp_data();
        })
        .catch((error) => {
          this.loading_anulacion = false;
          this.cdp_anulado = false;
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.anular(cod_cdp);
              })
              .catch((_) => {
                this.mensaje_error_anulacion =
                  'Hubo un error al anular su pedido. Inténtelo nuevamente.';
              });
          } else {
            this.mensaje_error_anulacion =
              'Hubo un error al anular su pedido. Inténtelo nuevamente.';
          }
        });
    },

    anular2(cod_cdp) {
      this.loading_correo_anulacion = true;
      axios({
        method: 'put',
        url: config_settings.RESOURCE_SERVER_URL + '/PUT/cdp/' + cod_cdp + '/null_post_track',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          console.log(response.data);
          this.mensaje_correo_anulacion = 'Su pedido de anulación fue enviado con éxito';
          this.loading_correo_anulacion = false;

          //this.cdp_anulado = true
        })
        .catch((error) => {
          this.cdp_anulado = false;
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.anular2(cod_cdp);
              })
              .catch((_) => {
                this.mensaje_correo_error_anulacion =
                  'Su pedido de anulación no pudo enviarse con éxito';
                this.loading_correo_anulacion = false;
              });
          } else {
            this.mensaje_correo_anulacion = 'Su pedido de anulación no pudo enviarse con éxito';
            this.loading_correo_anulacion = false;
          }
        });
    },

    ocultar_msjpwd() {
      this.mensaje_contraseña = '';
      this.mensaje_error_contraseña = '';
    },

    onFileChange(e) {
      const file = e.target.files[0];
      this.image_data = file;
      this.url_image_preview = URL.createObjectURL(file);
    },

    refreshToken() {
      var refresh_token = localStorage.getItem('refresh_token');
      var refresh_credentials = new FormData();
      refresh_credentials.append('grant_type', 'refresh_token');
      refresh_credentials.append('refresh_token', refresh_token);
      refresh_credentials.append('id_store', config_settings.STORE);

      const refreshingCall = axios({
        method: 'post',
        url: config_settings.AUTH_SERVER_URL + '/oauth/token',
        data: refresh_credentials,
        withCredentials: true,
        auth: {
          username: 'USER_CLIENT_APP',
          password: 'password',
        },
      }).then((response) => {
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    scroll_inicio() {
      window.scrollTo(0, 0);
    },

    get_cdp_data() {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/cdp',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.list_cdp = response.data.cdp;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = 1;
          this.mensaje_error = '';
          this.mensaje = '';

          if (this.selected_cdp == undefined) {
            this.last_cdp = this.list_cdp[0];
            var subtotal_real = 0.0;
            this.last_cdp.ventas_detalle.forEach((prod, index) => {
              subtotal_real =
                subtotal_real +
                (Math.round((prod.sale_price / 1.18) * 100) / 100) * prod.quantity * 1.18;
              //subtotal_real = subtotal_real + prod.subtotal;
            });
            //this.subtotal_real = subtotal_real
            this.subtotal_real = Math.round(subtotal_real * 100) / 100;
          } else {
            this.list_cdp.forEach((cdp_item, index) => {
              if (this.selected_cdp == cdp_item.cod_erp) this.last_cdp = cdp_item;
            });
            var subtotal_real = 0.0;
            this.last_cdp.ventas_detalle.forEach((prod, index) => {
              subtotal_real =
                subtotal_real +
                (Math.round((prod.sale_price / 1.18) * 100) / 100) * prod.quantity * 1.18;
              //subtotal_real = subtotal_real + prod.subtotal;
            });
            //this.subtotal_real = subtotal_real
            this.subtotal_real = Math.round(subtotal_real * 100) / 100;
          }

          this.get_trackingxcdp(this.list_cdp[0].cod_cdp);
          if (this.last_cdp.state_tracking.id_state == 7) {
            this.cdp_anulado = true;
          }
          this.get_delivery_detail(this.last_cdp.cod_cdp);

          //this.get_erpdata_cdp(this.last_cdp.cod_erp)
          this.get_cdp_erp_data(this.last_cdp.cod_erp);
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.get_cdp_data();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else {
            // toastr.error(error.response.data.details,
            //           error.response.data.message,
            //         {"iconClass": 'customer-danger'});
          }
        });
    },

    get_cdp_erp_data(cod_cdp_erp) {
      this.isCDPerpdata = false;
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/cdp_details/' + cod_cdp_erp,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          console.log(JSON.stringify(response.data));

          this.listaArticulos = response.data;
          if (listaArticulos.length != 0) {
            this.isCDPerpdata = true;
          }
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.get_cdp_erp_data(cod_cdp_erp);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else {
            console.log('No se encontro data del comprobante en erp');
            // toastr.error(error.response.data.details,
            //           error.response.data.message,
            //         {"iconClass": 'customer-danger'});
          }

          this.isCDPerpdata = false;
        });
    },

    get_delivery_detail(codcdp) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/cdp/' + codcdp + '/delivery_detail',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.delivery_detail_cdp = response.data;
          console.log(
            'Estamos aqui' +
              JSON.stringify(this.delivery_detail_cdp) +
              'Detalle delivery ' +
              this.delivery_detail_cdp.id_despacho.id_delivery,
          );
          this.get_delivery(this.delivery_detail_cdp.id_despacho.id_delivery);
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.get_delivery_detail(codcdp);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else {
            // toastr.error(error.response.data.details,
            //           error.response.data.message,
            //         {"iconClass": 'customer-danger'});
          }
        });
    },

    get_delivery(id) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/deliverys/' + id,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.delivery_detail = response.data;
          console.log('DETALLE DEL DELIVERY' + JSON.stringify(this.delivery_detail));
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.get_delivery(id);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else {
            // toastr.error(error.response.data.details,
            //           error.response.data.message,
            //         {"iconClass": 'customer-danger'});
          }
        });
    },

    get_trackingxcdp(cod_cdp) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/tracking/cdp/' + cod_cdp,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.list_track = response.data;
          console.log('Estos son los trackings ' + JSON.stringify(this.list_track));
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.get_trackingxcdp(cod_cdp);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else {
            // toastr.error(error.response.data.details,
            //           error.response.data.message,
            //         {"iconClass": 'customer-danger'});
          }
        });
    },

    get_erpdata_cdp(codcdp) {
      axios
        .get('')
        .then((response) => {
          this.cdp_erp_data = response.data;
          console.log('Esta es la data del erp: ' + JSON.stringify(this.cdp_erp_data));
          this.url_factura = this.cdp_erp_data[0].url;
          console.log('Este es el url de la factura: ' + this.url_factura);
        })
        .catch((error) => {
          console.log('Ocurrio un error al leer la data del erp ' + JSON.stringify(error));
          this.url_factura = '';
        });
    },

    get_page_data(page) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/cdp?nPag=' + page,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          this.list_cdp = response.data.cdp;
          this.pages = response.data.visible_pages;
          this.final_page = response.data.final_page;
          this.current_page = page;
          this.mensaje_error = '';
          this.mensaje = '';
          this.scroll_inicio();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.get_page_data(page);
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else if (error.response.status === NOT_FOUND) {
            this.get_page_data(page - 1);
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    ocultar() {
      this.mensaje = '';
      this.mensaje_error = '';
    },

    ocultar_anulacion() {
      this.mensaje_anulacion = '';
      this.mensaje_error_anulacion = '';
      this.mensaje_correo_anulacion = '';
      this.mensaje_error_correo_anulacion = '';
    },
  },
};
</script>
<style lang="scss" src="./TrackingView.scss"></style>
